/* eslint-disable max-len */
import { useSelector } from 'react-redux';
import { roleCondition } from '../../../../../../libs/HelperContent';

interface FeedApprovalConfig {
  requiresApproval: boolean;
  isFeedsAdmin: boolean;
}

const useFeedApproval = (): FeedApprovalConfig =>
{
	const companyConfigs = useSelector((state: any) => state?.mysession?.configs);
	const userData = useSelector((state: any) => state?.mysession?.session);
	// Check if user is an admin/approver
	const isAdminSuperAdmin = roleCondition(userData?.empRole);

	const currentUser = useSelector((state:any) => state?.mysession?.userConfigs);
	const isFeedsAdmin = isAdminSuperAdmin && currentUser?.feedManagement?.isAdminAdded && currentUser?.feedManagement?.hasManageAccess;

	return {
		requiresApproval : companyConfigs?.feedManagement?.feedApproval && !isFeedsAdmin,
		isFeedsAdmin
	};
};

export default useFeedApproval;
